import { getRequestHeaders, handleRes, logError } from 'utils';
import { Rule } from 'types';
export interface GetRuleResponse extends Response {
  rule?: Rule;
}
export interface GetRulesResponse extends Response {
  rules?: Array<Rule>;
}

interface GetRuleByIDParams {
  tenantID: number | string | undefined;
  ruleID: number | string | undefined;
}
export const getRuleByID = ({
  tenantID,
  ruleID,
}: GetRuleByIDParams): Promise<Rule> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rules/${ruleID}`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Rule>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface CreateRuleParams {
  tenantID: number | string | undefined;
  body: string; // RuleCreateBody as JSON string
}
export const createRule = async ({
  body,
  tenantID,
}: CreateRuleParams): Promise<GetRuleResponse> => {
  return await fetch(`${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rules`, {
    method: 'POST',
    ...getRequestHeaders(),
    body,
  });
};

interface UpdateRuleParams {
  ruleID: number | string | undefined;
  tenantID: number | string | undefined;
  body: string; // Rule as JSON string
}
export const updateRule = async ({
  ruleID,
  tenantID,
  body,
}: UpdateRuleParams): Promise<GetRuleResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rules/${ruleID}`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
      body,
    },
  );
};

export const getTenantRules = (
  tenantID: number | string | undefined,
  includeInactive?: boolean,
): Promise<Rule[]> => {
  const params = includeInactive ? '?includeInactive=true' : '';
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rules${params}`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Rule[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface PutPropertyRulesParams {
  tenantID: number | string | undefined;
  propertyID: number | string | undefined;
  body: string; // Rule[] as JSON string
}
export const putPropertyRules = async ({
  tenantID,
  propertyID,
  body,
}: PutPropertyRulesParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/rules`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
      body,
    },
  );
};

interface PutPropertyGroupRulesParams {
  tenantID: number | string | undefined;
  groupID: number | string | undefined;
  body: string; // Rule[] as JSON string
}
export const putPropertyGroupRules = async ({
  tenantID,
  groupID,
  body,
}: PutPropertyGroupRulesParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/rules`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
      body,
    },
  );
};

interface GetPropertyGroupRulesParams {
  tenantID: number | string | undefined;
  groupID: number | string | undefined;
  includeInactive?: boolean;
}
export const getPropertyGroupRules = ({
  tenantID,
  groupID,
  includeInactive,
}: GetPropertyGroupRulesParams): Promise<Rule[]> => {
  const params = includeInactive ? '?includeInactive=true' : '';
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/rules${params}`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Rule[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};
